<template>
  <div class="grid" ref="grid">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ["col", "row", "gap"],
  methods: {
    setColumns: function(col) {
      this.$refs.grid.style.setProperty("--columns", col);
    },
    setRows: function(row) {
      this.$refs.grid.style.setProperty("--rows", row);
    },
    setGap: function(gap) {
      this.$refs.grid.style.setProperty("--gap", gap);
    }
  },
  mounted() {
    this.setColumns(this.col);
    this.setRows(this.row);
    this.setGap(this.gap);
  },
  watch: {
    col: function(val) {
      this.setColumns(val);
    }
  }
};
</script>

<style style scoped>
.grid {
  --columns: 1fr;
  --rows: 1fr;
  --gap: 0;
  display: grid;
  grid-template-columns: var(--columns);
  grid-template-rows: var(--rows);
  grid-gap: var(--gap);
}
</style>




// WEBPACK FOOTER //
// gridX.vue?03d2b892